import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../../../../app/store";
import axiosInstance from "../../../../../../../configs/axios/axios ";
import {
  ALTERNATIVE_FILE,
  SEARCH_FILE_FOLDER,
} from "../../../../../../../configs/axios/constantsAPI";
import { getCookie } from "../../../../../../../configs/cookie-helper/cookieHelper";

export const getAlternativeFileAction = createAsyncThunk(
  "drawerShare/getAlternativeFile",
  async (_, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(ALTERNATIVE_FILE, _, {
        headers: {
          token: token ? token : getState().authenticationState.token,
        },
      });
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const searchAlternativeFileAction = createAsyncThunk(
  "drawerShare/searchAlternative",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        SEARCH_FILE_FOLDER,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface Items {
  id: string;
  name: string;
  type: string;
  size: string;
}

export interface AlternativeFileModalState {
  openModal: boolean;
  alternativeFile: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    items: Array<Items>;
  };
  selectedAlternativeFile: Items;
}

const initialState: AlternativeFileModalState = {
  openModal: false,
  alternativeFile: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    items: [],
  },
  selectedAlternativeFile: {
    id: "",
    name: "",
    type: "",
    size: "",
  },
};

export const alternativeFileModalSlice = createSlice({
  name: "alternativeFileModal",
  initialState,
  reducers: {
    alternativeFileModalAction: (state, action: PayloadAction<boolean>) => {
      state.openModal = action.payload;
    },
    setSelectedAlternativeFileAction: (state, action: PayloadAction<Items>) => {
      state.selectedAlternativeFile = action.payload;
    },
    deleteSelectedAlternativeFileAction: (state) => {
      state.selectedAlternativeFile = initialState.selectedAlternativeFile;
    },
    resetSearchAlternativeFileAction: (state) => {
      state.alternativeFile = initialState.alternativeFile;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getAlternativeFileAction.pending, (state) => {
      state.alternativeFile.actionStatus = "loading";
      state.alternativeFile.alert = {
        error: false,
        message: "",
      };
    });
    addCase(getAlternativeFileAction.fulfilled, (state, { payload }) => {
      state.alternativeFile.actionStatus = "success";
      state.alternativeFile.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      state.alternativeFile.items = payload.content?.data;
    });
    addCase(getAlternativeFileAction.rejected, (state, { payload }: any) => {
      state.alternativeFile.actionStatus = "rejected";
      state.alternativeFile.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });

    addCase(searchAlternativeFileAction.pending, (state) => {
      state.alternativeFile.actionStatus = "loading";
      state.alternativeFile.alert = {
        error: false,
        message: "",
      };
    });
    addCase(searchAlternativeFileAction.fulfilled, (state, { payload }) => {
      state.alternativeFile.actionStatus = "success";
      state.alternativeFile.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      let newItems = [];
      for (let i = 0; i < payload.content.files?.length; i++) {
        const makedPath = {
          ...payload.content.files[i],
          path: payload.content.files[i]?.path
            ?.split("/")
            .filter((item: string, index: number) => index > 2)
            .join("/")
            ? `/${payload.content.files[i].path
                ?.split("/")
                .filter((item: string, index: number) => index > 2)
                .join("/")}`
            : "",
        };
        newItems.push(makedPath);
      }
      state.alternativeFile.items = newItems;
    });
    addCase(searchAlternativeFileAction.rejected, (state, { payload }: any) => {
      state.alternativeFile.actionStatus = "rejected";
      state.alternativeFile.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const {
  alternativeFileModalAction,
  setSelectedAlternativeFileAction,
  deleteSelectedAlternativeFileAction,
  resetSearchAlternativeFileAction,
} = alternativeFileModalSlice.actions;

export const alternativeFileModal = (state: RootState) =>
  state.alternativeFileModalState;

export default alternativeFileModalSlice.reducer;
